import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import mobile_grocery from "../../Assets/Projects/grocery_store_mobile_app.jpg";
import auth from "../../Assets/Projects/flutter_auth.jpg";
import employee from "../../Assets/Projects/employee_dashboard.jpg";
import helm from "../../Assets/Projects/helm.jpg";
import Flutter from "../../Assets/Projects/flutter_chatbot.jpg";
import Tauri from "../../Assets/Projects/tauri_grocery.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Tauri}
              isBlog={false}
              title="Grocery Store Desktop App"
              description="A lightweight, local-first Desktop POS & Inventory Manager for small grocery stores, built with Tauri, React, and SQLite. Features fast, offline-capable inventory control, a simple Point-of-Sale (POS) system for processing sales, and secure, local data storage using an onboard SQLite database."
              ghLink="https://github.com/AitazazAhmad/tauri-store-project.git"
              demoLink="https://drive.google.com/file/d/14t_AICVM82XSQ7Bu_d969FNEheW_Bbpd/view?usp=drive_link"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Flutter}
              isBlog={false}
              title="Chat Bot"
              description="A mobile Speech-to-Text note-taking app built with Flutter and a local database (like SQLite). Has features allowing users to capture notes via real-time voice transcription or typing, save notes locally to the device, and listen back to them using text-to-speech. Also supports full note management including editing and deleting saved entries."
              ghLink="https://github.com/AitazazAhmad/Flutter-chatbot.git"
              demoLink="https://drive.google.com/file/d/1qtxWeEaxUxA_QF3aDQUy7Yrtxc6aWX-y/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={employee}
              isBlog={false}
              title="Employee Management Dashboard"
              description="This is a web-based Employee Dashboard built for managing and tracking an employee's work and financial data. It provides an overview of project metrics, task status, time-off requests, and detailed monthly salary information, supported by a visual salary history chart. The entire application is easily developed using the PHP language."
              ghLink="https://github.com/AitazazAhmad?tab=repositories"
              // demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mobile_grocery}
              isBlog={false}
              title="Grocery Store Mobile App"
              description="This is a mobile grocery product management application built using the Flutter framework. It features a local inventory system where users can add, view, edit, and delete grocery items. The application utilizes a local SQLite database to securely store user login information and maintain the list of product data."
              ghLink="https://github.com/AitazazAhmad/flutter-store-task-sqlite.git"
              demoLink="https://drive.google.com/file/d/1dwr6Ks6_ERk6vLedaJ-LyIG_vVYAXpMo/view?usp=drive_link"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={helm}
              isBlog={false}
              title="Helm Text Manipulator"
              description="Core Functions:Instant, one-click text conversions like Uppercase, Lowercase, Copy Text, Clear Text, and Remove Extra Spaces are available.Assistive Features:Includes integrated Text-to-Speech(TTS)and immediate Content Analysis(word/character count, header summary).Frontend Tech: Developed using React with TypeScript for a robust and type-safe user interface.Backend & DB: Uses PocketBase as a NoSQL database for secure data persistence, serving as a complete backend solution."
              ghLink="https://github.com/AitazazAhmad/TextUtils_Ts.git"
              demoLink="https://helm-text.netlify.app/" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={auth}
              isBlog={false}
              title="Mobile Authentication App"
              description=" This mobile application is a modern, lightweight, and secure user authentication system built using the Flutter framework. It features a clean and minimal UI, similar to the image you provided, offering a smooth and intuitive onboarding experience.

The app allows users to Sign Up, Log In, and securely manage their account data directly on the device without requiring an external server."
              ghLink="https://github.com/AitazazAhmad/flutter-login-sqlite.git"
              demoLink="https://drive.google.com/file/d/1YX6LBnAtCeynUwJxvTA4fiHQq23oxycW/view?usp=drive_link"      
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
